import { Navigate } from "react-router-dom";
import { useFeatureFlag } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { FeatureFlagType } from "src/generated/graphqlTypes";
import { useRouteParams } from "src/hooks/useRouteParams";
import { GlobalProductOfferings } from "src/routes/libraries/product-offerings/GlobalProductOfferings";
import { DevelopmentParams, ProjectParams } from "src/routes/routesDef";
import { projectProductOfferingsOverviewRoute } from "src/routing/domains/projectsPaths";

/** Development list entry that scopes GlobalProductOfferings to the current development. */
export function DevelopmentProductOfferings() {
  const { developmentId } = useRouteParams<DevelopmentParams>();
  return <GlobalProductOfferings developmentId={developmentId} />;
}

/** Project list entry that scopes GlobalProductOfferings to the current project. */
export function ProjectProductOfferings() {
  const isProductOfferingsV2Enabled = useFeatureFlag(FeatureFlagType.ProductOfferingsV2);
  const { projectId } = useRouteParams<ProjectParams>();
  if (isProductOfferingsV2Enabled) {
    return <Navigate to={projectProductOfferingsOverviewRoute.url({ projectId })} replace />;
  }
  return <GlobalProductOfferings projectId={projectId} />;
}
